import { render, staticRenderFns } from "./BaseRadioSwitch.vue?vue&type=template&id=09c2f048&scoped=true&"
import script from "./BaseRadioSwitch.vue?vue&type=script&lang=js&"
export * from "./BaseRadioSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../log-in-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c2f048",
  null
  
)

export default component.exports